import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import jwtDecode from 'jwt-decode';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { API_ENDPOINT } from '../../_constants/endpoints';
import { AuthModel } from '../_models/auth.model';

const API_REVOKE_TOKEN = `${API_ENDPOINT}revoke/token`;
const API_REFRESH_TOKEN = `${API_ENDPOINT}auth/login`;

@Injectable({providedIn: 'root'})
export class AuthTokenService {
  refreshToken: string;

  private http: HttpClient;

  constructor(handler: HttpBackend, private cookieService: CookieService) {
    this.http = new HttpClient(handler);
  }

  public revokeToken(userId: string) {
    let httpHeaders = new HttpHeaders();
    httpHeaders = httpHeaders.set('refresh', this.refreshToken);
    return this.http.post(
      `${API_REVOKE_TOKEN}/${userId}`,
      {},
      {headers: httpHeaders}
    );
  }

  public refreshTheToken(): Observable<AuthModel> {

    return this.http.post<AuthModel>(
      API_REFRESH_TOKEN,
      {
        key: '',
        secret: ''
      }
    );
  }

  getTokenExpirationDate(token: string): Date {
    let decoded;
    try {
      decoded = jwtDecode(token);
      // decoded = jwt_decode(token);
    } catch (e) {
      return null;
    }
    if (decoded.exp === undefined) {
      return null;
    }
    const date = new Date(0);
    date.setUTCSeconds(decoded.exp);
    return date;
  }

  isTokenExpired(token: string): boolean {
    if (!this.getTokenExpirationDate(token)) {
      return true;
    }
    const date = this.getTokenExpirationDate(token);
    if (date === undefined) {
      return false;
    }
    return !(date.valueOf() > new Date().valueOf());
  }
}
